<template>
  <div class="home">
    <el-container style="height: 100%">
      <el-header class="header">
        <div class="container">
          <img
            class="logo"
            src="@/assets/imgs/front/icon_weikeyunji_logo_blue.svg"
            alt=""
            @click="$router.push('/')"
          >
          <nav>
            <el-menu
              :default-active="defaultActive"
              class="el-menu-demo"
              mode="horizontal"
              @select="handleSelect"
            >
              <el-menu-item index="index">首页</el-menu-item>
              <el-menu-item index="apiMarket">API市场</el-menu-item>
              <el-submenu
                popper-class="doc-center"
                index="doc"
              >
                <template slot="title">文档中心</template>
                <el-menu-item index="document">开发者文档</el-menu-item>
                <el-menu-item index="apiDocument">API文档</el-menu-item>
              </el-submenu>
              <el-menu-item index="notice">平台公告</el-menu-item>
            </el-menu>
          </nav>
          <div
            v-if="user"
            class="btns"
          >
            <el-button
              type="primary"
              size="small"
              @click="gotoControl"
              style="margin-right: 20px"
            >控制台</el-button>
            <el-dropdown
              @command="handleCommand"
              placement="bottom"
            >
              <div class="user">
                <img
                  class="weixin"
                  v-if="user.avatar"
                  :src="user.avatar"
                  alt=""
                  width="32px"
                  height="32px"
                />
                <img
                  class="weixin"
                  v-else
                  src="@/assets/imgs/icon_avtar_def@2x.png"
                  alt=""
                  width="32px"
                  height="32px"
                />
                <span>{{user.mobile && user.mobile.substr(0,3)}}****{{user.mobile && user.mobile.substr(7,4)}}</span>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  command="logout"
                  style="width:130px"
                >退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </div>
          <div
            class="btns"
            v-else
          >
            <el-button
              type="text"
              size="small"
              class="login"
              @click="login"
            >登录</el-button>
            <el-button
              type="primary"
              size="small"
              class="register"
              @click="register"
            >注册</el-button>
          </div>

        </div>
      </el-header>
      <el-main class="content">
        <router-view @login="login" />
        <div class="footer">
          <div>
            <div class="enter-links">
              <div class="links product">
                <p class="title">产品</p>
                <p
                  class="name"
                  v-for="(p, index) in product"
                  :key="index"
                  @click="goto(p.path)"
                >{{ p.name }}</p>
              </div>
              <div class="links product">
                <p class="title">新手入门</p>
                <p
                  class="name"
                  @click="goPath(1)"
                >平台公告</p>
                <p
                  class="name"
                  @click="goPath(2)"
                >平台规范</p>
                <p
                  class="name"
                  @click="$router.push('apiMarket')"
                >在线文档</p>

              </div>
              <div class="links contact">
                <p class="title">联系方式</p>
                <p class="name">客服电话：{{ conf.tel }}</p>
                <p class="name">客服微信：{{ conf.wechat }}</p>
                <p class="name">公司地址：南京市雨花区世茂52+ C栋</p>
              </div>
              <div class="links product">
                <p class="title">扫码关注</p>
                <img
                  src="http://www.wikeyun.cn/template/web/images/sys_public.jpg"
                  width="110px"
                  alt=""
                >
              </div>
            </div>
            <div class="copyright">
              <p>© 2017- 2020 南京言午网络科技有限公司 苏ICP备18034104号-5 增值电信业务许可：苏B2-20201723 微客云 . All Right Reserved</p>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>

    <register
      ref="register"
      @login="login"
      @loginSuccess="refreshUser"
    ></register>
    <login
      ref="login"
      @register="register"
      @loginSuccess="refreshUser"
    ></login>

  </div>
</template>

<script>
import register from './register'
import login from './login'
import auth from "@/utils/auth"
import apis from "@/api/apis"
export default {
  name: 'fontHome',
  components: { register, login },
  data () {
    return {
      conf: {},
      user: auth.getUser(),
      defaultActive: this.$route.meta.menuName,
      product: [
        {
          name: '微客云',
          path: 'http://www.wikeyun.cn/'
        },
        {
          name: '私域小程序系统',
          path: 'http://www.wikeyun.cn/product/mini.html'
        },
        {
          name: '私域公众号系统',
          path: 'http://www.wikeyun.cn/product/public.html'
        },
        {
          name: '私域电商APP',
          path: 'http://www.wikeyun.cn/product/app.html'
        },
        {
          name: '社群管理系统',
          path: 'http://www.wikeyun.cn/product/group.html'
        }
      ]
    }
  },
  mounted () {
    this.getIndex()
  },
  methods: {
    goPath (val) {
      if (val == 1) {
        window.open('https://open.wikeyun.cn/#/notice/0', '_blank')
      } else if (val == 2) {
        window.open('https://open.wikeyun.cn/#/notice/80', '_blank')
      }
    },
    goto (path) {
      window.open(path, '_blank')
    },
    gotoControl () {
      this.$router.push('/control')
    },
    refreshUser () {
      this.user = auth.getUser()
    },
    handleSelect (name) {
      this.$router.push(`/${name}`)
    },
    register (loginId, openId) {
      this.$refs.register.showDialog(loginId, openId)
    },
    login () {
      this.$refs.login.showDialog()
    },
    handleCommand (command) {
      if (command === 'logout') {
        this.logout()
      }
    },
    logout () {
      apis.login.loginOut().then(res => {
        if (res.code) {
          auth.removeUser()
          auth.removeToken()
          auth.removeSkey()
          this.user = null
        }
      })
    },
    getIndex () {
      apis.index.index().then(res => {
        this.conf = res.data.conf
      })
    }
  },
}

</script>

<style lang="scss" scoped>
@import 'src/assets/styleVar.scss';
.home {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  ::v-deep.el-main {
    padding: 0;
  }
  .doc-center {
    width: 150px;
    ::v-deep.el-menu-item {
      font-size: 12px;
      font-weight: 400;
      color: #1e1e28;
      line-height: 34px;
      &.is-active {
        color: #0b4ffc;
      }
    }
  }
  .header {
    width: 100%;
    box-sizing: content-box;
    overflow-x: auto;
    .container {
      width: 1280px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .logo {
        cursor: pointer;
      }
      .btns {
        width: 260px;
        padding-right: 20px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .login {
          color: $green;
        }
        .register {
          margin-left: 20px;
        }
      }
      .user {
        width: 130px;
        margin: 0 20px;
        display: flex;
        align-items: center;
        span {
          cursor: pointer;
          margin-left: 20px;
        }
      }
    }
  }
  .content {
  }
  .footer {
    width: 100%;
    background: #1e1e28;
    & > div {
      width: 1280px;
      margin: auto;
      background: #1e1e28;
      .enter-links {
        box-sizing: border-box;
        padding-top: 100px;
        padding-left: 150px;
        height: 304px;
        margin: 0 24px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        display: flex;
        .links {
          width: 180px;
          .title {
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;
            line-height: 25px;
            text-align: left;
          }
          .name {
            font-size: 12px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.6);
            line-height: 30px;
            cursor: pointer;
            &:hover {
              font-weight: 400;
              color: #fff;
            }
          }
          &.contact {
            width: 280px;
          }
        }
      }
      .copyright {
        color: #ccc;
        height: 95px;
        line-height: 95px;
        p {
          text-align: center;
          font-size: 12px;
          span {
            color: $green;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
